import { render } from "./AssessmentList.molecules.vue?vue&type=template&id=26f0491f&ts=true"
import script from "./AssessmentList.molecules.vue?vue&type=script&lang=ts"
export * from "./AssessmentList.molecules.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__